import { TrimmedOfferLocations } from 'components/TrimmedOfferLocations';
import { useI18n } from 'hooks/useI18n';
import { UIOfferWhereSection } from 'interfaces/ui/ui-offer-where-section';
import {
  StyledWhereSummary,
  StyledWhereSummaryItem,
  StyledWhereSummaryItemTitle,
  StyledWhereSummarySeparator,
  StyledWhereSummaryValue
} from './WhereSummary.styled';

const WhereSummary: React.FC<
  Pick<UIOfferWhereSection, 'jobLocationsSummary' | 'jobRemote'>
> = ({ jobLocationsSummary, jobRemote }) => {
  const { t } = useI18n('job-offer');
  const hasLocations = jobLocationsSummary.trimmedCount > 0;

  return (
    <StyledWhereSummary>
      {jobRemote === 100 ? (
        <>
          <StyledWhereSummaryItem>
            <StyledWhereSummaryItemTitle>
              {t('where.remote')}
            </StyledWhereSummaryItemTitle>
            <StyledWhereSummaryValue>{jobRemote}%</StyledWhereSummaryValue>
          </StyledWhereSummaryItem>

          {hasLocations && jobRemote < 100 && jobRemote > 0 && (
            <StyledWhereSummarySeparator>
              {t('hero.and')}
            </StyledWhereSummarySeparator>
          )}

          {hasLocations && jobRemote === 100 && (
            <StyledWhereSummarySeparator>
              {t('hero.or')}
            </StyledWhereSummarySeparator>
          )}

          {hasLocations && (
            <StyledWhereSummaryItem>
              <StyledWhereSummaryItemTitle>
                {t('where.presential')}
              </StyledWhereSummaryItemTitle>
              <StyledWhereSummaryValue>
                <TrimmedOfferLocations locationsSummary={jobLocationsSummary} />
              </StyledWhereSummaryValue>
            </StyledWhereSummaryItem>
          )}
        </>
      ) : (
        <>
          {hasLocations && (
            <StyledWhereSummaryItem>
              <StyledWhereSummaryItemTitle>
                {t('where.presential')}
              </StyledWhereSummaryItemTitle>
              <StyledWhereSummaryValue>
                <TrimmedOfferLocations locationsSummary={jobLocationsSummary} />
              </StyledWhereSummaryValue>
            </StyledWhereSummaryItem>
          )}

          {hasLocations && jobRemote < 100 && jobRemote > 0 && (
            <StyledWhereSummarySeparator>
              {t('hero.and')}
            </StyledWhereSummarySeparator>
          )}

          {hasLocations && jobRemote === 100 && (
            <StyledWhereSummarySeparator>
              {t('hero.or')}
            </StyledWhereSummarySeparator>
          )}

          {jobRemote !== 0 && (
            <StyledWhereSummaryItem>
              <StyledWhereSummaryItemTitle>
                {t('where.remotework')}
              </StyledWhereSummaryItemTitle>
              <StyledWhereSummaryValue>{jobRemote}%</StyledWhereSummaryValue>
            </StyledWhereSummaryItem>
          )}
        </>
      )}
    </StyledWhereSummary>
  );
};

export default WhereSummary;
